// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2qwfQ","title":"ClientInsurance_title__2vd2I","itemText":"ClientInsurance_itemText__1kBz6"};